import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Adónde regresar al iniciar sesión. Quien manda a alguien a entrar (una pantalla privada, «Reservar», «Cotizar», el corazón,
// «Iniciar sesión», «Regístrate», la sesión vencida) guarda aquí la pantalla, y el login o el registro la usan al entrar.
// Vive en la pestaña (sessionStorage): sobrevive a crear la cuenta, a recuperar la contraseña y a la recarga de la sesión vencida.
const CLAVE = 'destinoAlEntrar';

// Las pantallas para entrar (/login, /signup y sus pasos, /forgot-pass) y el panel de administración nunca son el destino:
// desde ellas se conserva el que ya había
const ENTRADA = /^\/(login|signup|forgot-pass|admin)/i;

// Solo una ruta de esta web: "/algo". No "//otro.sitio" ni "/\otro.sitio", que el navegador abre como otro dominio, ni con
// tabuladores o saltos de línea (el navegador los quita: "/\t/otro.sitio" quedaría en "//otro.sitio")
export const rutaValida = ruta =>
  typeof ruta === 'string' && /^\/(?![/\\])/.test(ruta) && !/[\t\n\r]/.test(ruta) && !ENTRADA.test(ruta);

// La ruta completa (con ?búsqueda y #ancla) de una ubicación del router o de window.location
export const rutaDe = ({ pathname = '', search = '', hash = '' } = {}) => `${pathname}${search}${hash}`;

export const recordarDestino = ruta => {
  if (!rutaValida(ruta)) return;
  try {
    sessionStorage.setItem(CLAVE, ruta);
  } catch (e) {
    // Sin almacenamiento (el navegador lo bloquea): al entrar se va al inicio, como antes
  }
};

export const destinoRecordado = () => {
  try {
    const ruta = sessionStorage.getItem(CLAVE);
    return rutaValida(ruta) ? ruta : null;
  } catch (e) {
    return null;
  }
};

export const olvidarDestino = () => {
  try {
    sessionStorage.removeItem(CLAVE);
  } catch (e) {
    // Nada que olvidar
  }
};

// Manda a iniciar sesión (o a crear la cuenta con '/signup') y recuerda la pantalla actual, o `destino` si se da otro
export const useIrAEntrar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (pantalla = '/login', destino = rutaDe(location)) => {
    recordarDestino(destino);
    navigate(pantalla);
  };
};

// Login y registro: adónde ir al entrar (lo recordado o el inicio). Al pintar solo se lee; se olvida ya con la sesión iniciada
export const useDestinoAlEntrar = entro => {
  const destino = destinoRecordado() || '/';
  useEffect(() => {
    if (entro) olvidarDestino();
  }, [entro]);
  return destino;
};

// Una pantalla que ya tiene la sesión y sigue con un botón (el último paso del registro): al tocarlo lleva a lo recordado (o al
// inicio) sin dejar esa pantalla en el historial, y lo olvida. Se lee al tocar, no al pintar: hasta entonces el destino sigue guardado.
export const useIrAlDestino = () => {
  const navigate = useNavigate();
  return () => {
    const destino = destinoRecordado() || '/';
    olvidarDestino();
    navigate(destino, { replace: true });
  };
};
